<template>
  <div class="testimonials-slider w-full h-full py-16 lg:py-28 relative z-0">
    <SharedPicture
      :loading="index < 3 ? 'eager' : 'lazy'" 
      :media="component.testimonialsBackground"
      class="w-full h-full object-cover absolute top-0 left-0 -z-20 block md:hidden"
      height="768"
      width="768"
      format="webp"
      :quality="80"
    />
    <SharedPicture
      :loading="index < 3 ? 'eager' : 'lazy'" 
      :media="component.testimonialsBackground"
      class="w-full h-full object-cover absolute top-0 left-0 -z-20 !hidden md:!block lg:!hidden"
      height="768"
      width="1024"
      format="webp"
      :quality="80"
    />
    <SharedPicture
      :loading="index < 3 ? 'eager' : 'lazy'" 
      :media="component.testimonialsBackground"
      class="w-full h-full object-cover absolute top-0 left-0 -z-20 !hidden lg:!block xl:!hidden"
      height="768"
      width="1280"
      format="webp"
      :quality="80"
    />
    <SharedPicture
      :loading="index < 3 ? 'eager' : 'lazy'" 
      :media="component.testimonialsBackground"
      class="w-full h-full object-cover absolute top-0 left-0 -z-20 !hidden xl:!block"
      height="768"
      width="1680"
      format="webp"
      :quality="80"
    />
    <div class="absolute inset-0 bg-primary/60 -z-10"></div>
    <div class="testimonials-slider__content container container--page-content relative z-10">
      <h2 class="text-white text-center mb-12 md:text-left lg:mb-20">
        {{ component.testimonialsTitle }}
      </h2>
      <PageComponentsTestimonialsSliderComponent :testimonials="component.testimonials" :loading="index < 3 ? 'eager' : 'lazy'" class="w-full overflow-hidden" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { GraphQLTestimonialsSlider } from '~/types/graphql';

  const props = defineProps<{
    component: GraphQLTestimonialsSlider;
    index: number;
  }>();

  const { component } = toRefs(props);
</script>

<style scoped></style>
